import { HelpCircle } from "../../assets/icons";

export const gasAvailabilityOptions = [
    { id: "1", name: "Yes" },
    { id: "2", name: "No" },
];

export const helpIcons = {
    component: <HelpCircle />,
    tooltipText: "Info",
};

export const typeOfShaft = [
    {
        label: "High Strength",
        value: "0",
    },
    {
        label: "Standard",
        value: "1",
    },
];

export const emptyEquipment = [
    {
        id: "",
        pump: "",
        series: "",
        name: "",
        partNumber: "",
        pN_Description: "",
        length: "--",
        weight: "--",
        standardization: "",
        noStgs: "",
        text: "",
        aalS_Description: "",
        configuration: "",
        bearingType: "",
        shaftMaterial: "",
        sensorId: "",
        equipmentStatus: "",
        international: "",
        permian: "",
        diameter: "--",
        parentId: "",
        equipmentjson: "",
        setDepth: "--",
        pn: "--",
        equipmentName: "",
        equipmentId: "",
        totalLength: "--",
        dimensions: "",
        nominalWeight: "",
        oracle_Item_Number: "",
        transformers: "",
        od: "--",
        size: "",
        current: "",
        voltage: "",
        dimension: "",
        kva: "",
        sec: "",
        sec_Y: "",
        accBelowESP: "",
        accAboveESP: "",
        equipments: "",
        shaftType: "",
        originalNominalWeight: "",
    }
];


